<template>
    <div id="userList">

        <div class="search">
            <div class="p_select select_day">
                <div class="search_label">查询日期</div>
                <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                    <el-date-picker v-model="startDay"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerDayOptions"
                                    prefix-icon="''"
                                    class="datepicker"
                                    placeholder="选择开始日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateStart"></i>
                </div>
            </div>

            <div class="p_select select_day">
                <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                    <el-date-picker v-model="endDay"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerDayOptions"
                                    prefix-icon="''"
                                    class="datepicker"
                                    placeholder="选择结束日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateEnd"></i>
                </div>
            </div>

            <div class="p_select">
                <a class="search_btn" @click="searchData">查询</a>
            </div>
        </div>

        <div class="table">
            <el-table
                    :data="conditionList"
                    :height="tableHeight"
                    show-summary
                    ref="table_day"
            >
                <!--<el-table-column label="日期">
                    <template slot-scope="scope">
                        {{ scope.row.dayIndex.slice(0, 4) }}-{{
                        scope.row.dayIndex.slice(4, 6)
                        }}-{{ scope.row.dayIndex.slice(6, 8) }}
                    </template>
                </el-table-column>-->
                <el-table-column label="日期" prop="dayIndex"></el-table-column>

                <el-table-column
                        prop="tireOtherDeal"
                        label="轮胎其他成交数(条)"
                ></el-table-column>
                <el-table-column
                        prop="batteryOtherDeal"
                        label="蓄电池其他成交数(个)"
                ></el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <a  v-if="!(scope.row.value !== '-')" @click="onClickRowButton(scope.row)"><span class="test_detail" style="border: 1px solid #29D3BF;color: #29D3BF;">录入</span></a>
                        <a  v-else @click="onClickRowButton(scope.row)" class="test_detail" size="small" style="border: 1px solid #E04066;color: #E04066;">重录</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>



        <el-drawer
                title="请输入其他成交数"
                :visible.sync="dialogVisible"
                direction="rtl"
                :wrapperClosable=true
                @close="dialogVisible = false">
            <el-form label-width="160px" style="height: 300px; ">

                <el-form-item label="日期:">
                    <el-input
                            disabled
                            v-model="dayIndex"
                            clearable
                    ></el-input>
                </el-form-item>

                <el-form-item label="轮胎其他成交数(条):">
                    <el-input
                            placeholder="请输入轮胎其他成交数(条)"
                            v-model="tireOtherDeal"
                            clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="蓄电池其他成交数(个):">
                    <el-input
                            placeholder="请输入蓄电池其他成交数(个)"
                            v-model="batteryOtherDeal"
                            clearable
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a @click="ensure" class="sure_btn">确 定</a>
                <a @click="dialogVisible = false" class="cancel_btn">取 消</a>
            </div>
        </el-drawer>


    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import moment from 'moment'
  export default {
    data() {
      return {
        tableHeight: "200",
        groupArr: [],
        groupName: "",
        loginUserOrgId: "",
        orgId: "",
        orgIdArr: [],
        queryMonth: "",
        conditionList: [],
        pickerOptions: {
          disabledDate(time) {
            let year = new Date().getFullYear();
            let month = new Date().getMonth();
            let days = new Date(year, month, 0).getDate();
            const timeDifference = days; // 时间差
            let startDatd = new Date("2019-11").getTime();
            return (
              time.getTime() > Date.now() - timeDifference ||
              time.getTime() < startDatd
            );
          },
        },

        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
        startDay:'',
        endDay:'',
        dateList:[],

        dialogVisible: false,
        bizId: "",
        dayIndex: "",
        tireOtherDeal: "",
        batteryOtherDeal:"",
      };
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));

      this.orgId = signInfo.orgId;

      let obj = new Date();
      let month = obj.getMonth() + 1;
      let lastMonth = month+1 > 12 ? '1' : month+1
      let lastYear = month+1 > 12 ? obj.getFullYear()+1 : obj.getFullYear()
      if (month < 10) month = "0" + month;
      if (lastMonth < 10) lastMonth = "0" + lastMonth;


      this.queryMonth = obj.getFullYear() + "-" + month; // 本月

      this.startDay = obj.getFullYear() + "-" + month + '-01';
      this.endDay = lastYear + "-" + lastMonth + '-01';

      this.queryMonthToDayList()
    },
    methods: {
      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },


      queryMonthToDayList() {
        if ( this.startDay === "" || this.startDay === null || this.endDay === null || this.endDay === null ) {
          net.message(this, "请选择查询月份", "warning");
          return;
        }
        this.getEveryDay(this.startDay, this.endDay)
        const params = {
          orgId: this.orgId,
          dayIndexStart: this.startDay,
          dayIndexEnd: this.endDay
        };
        net.request("admin/manage/orgDayOtherDeal/getList", "post", null, params).then((res) => {
          if (res.code === 0) {
            const existingData = res.data || []; // 后端返回的已有数据（有录入的日期）

            // 3. 合并完整日期与已有数据
            const mergedData = this.dateList.map(fullDate => {
              // 查找当前完整日期是否有对应的已有数据
              const matchedData = existingData.find(item => {
                // 确保两端日期格式一致（后端dayIndex可能是YYYY-MM-DD，直接匹配）
                return item.dayIndex === fullDate.dayIndex;
              });
              // 有匹配数据则用已有数据，无则用默认空值（成交数默认为空，操作显示“录入”）
              return {
                dayIndex: fullDate.dayIndex,
                tireOtherDeal: matchedData && matchedData.tireOtherDeal? matchedData.tireOtherDeal : "", // 轮胎其他成交数（无数据为空）
                batteryOtherDeal: matchedData && matchedData.batteryOtherDeal? matchedData.batteryOtherDeal : "", // 蓄电池其他成交数（无数据为空）
                bizId: matchedData && matchedData.bizId? matchedData.bizId : 0, // 用于后续编辑/重录（无数据为0）
                value: matchedData ? "已录入" : "-" // 控制操作按钮显示“录入”/“重录”
              };
            });

            // 4. 按日期升序排序（从早到晚）
            mergedData.sort(this.compareAsc("dayIndex"));

            // 5. 赋值并更新表格
            this.conditionList = mergedData;
            // 适配表格高度
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight;
            this.tableHeight = windiwHight - 200;
            // 强制表格重绘（解决高度适配问题）
            this.$nextTick(() => {
              this.$refs["table_day"].doLayout();
            });
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      onClickRowButton(data) {
        this.tireOtherDeal = "";
        this.batteryOtherDeal = "";
        this.dayIndex = data.dayIndex;
        this.bizId = data.bizId || 0;
        this.dialogVisible = true;
      },
      ensure() {
        //补录对应日期的进站台次
        if (this.dayIndex === "" || this.dayIndex === null) {
          net.message(this, "请刷新后重试", "warning");
          return;
        }
        // if (this.incomeCarNum === "" || this.incomeCarNum === null) {
        //   net.message(this, "输入进站台次", "warning");
        //   return;
        // }
        // if (this.incomeCarNum < 0) {
        //   net.message(this, "进站台次不能小于0", "warning");
        //   return;
        // }
        net
          .request(
            "admin/manage/orgDayOtherDeal/saveOrUpdate",
            "post",
            null,
            {
              bizId: this.bizId || 0,
                orgId: this.orgId,
              dayIndex: this.dayIndex,
              tireOtherDeal: this.tireOtherDeal,
              batteryOtherDeal: this.batteryOtherDeal
            }
          )
          .then((res) => {
            if (res.code === 0) {
              this.dialogVisible = false;
              this.searchData();
            } else {
              net.message(this, res.msg, "warning");
            }
          });
      },
      searchData() {
        this.queryMonthToDayList();
      },
      // 排序 降序
      compareDes: function (property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          return value2 - value1;
        };
      },
      // 排序 升序
      compareAsc(property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          // 字符串格式的YYYY-MM-DD可直接比较大小
          if (value1 < value2) return 1;
          if (value1 > value2) return -1;
          return 0;
        };
      },

      //查询日期数组
      getEveryDay(startDay, endDay) {
        this.dateList = [];
        let currentDate = moment(startDay); // 起始日期
        const endDate = moment(endDay); // 结束日期

        // 循环生成所有日期（包含起始和结束日）
        // while (currentDate.isSameOrBefore(endDate)) {
        while (currentDate.isBefore(endDate)) {
          this.dateList.push({
            dayIndex: currentDate.format("YYYY-MM-DD"), // 统一日期格式为YYYY-MM-DD
            value: "-" // 标记为未录入（后续合并用）
          });
          // 日期加1天
          currentDate.add(1, "days");
        }
      },

      getDate(datestr) {
        let temp = datestr.split("-");
        let date = new Date(temp[0], temp[1], temp[2]);
        return date;
      },

    },
  };
</script>


<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        margin-left: 24px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 12px;
        .search {
            /*display: flex;*/
            flex-wrap: wrap;
            background: #fff;
            .p_select {
                display: flex;
                padding: 0 0 12px 0;
                font-size: 12px;
                float: left;
                margin-right: 12px;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
        }
        .search_btn {
            width: 76px;
            height: 36px;
            line-height: 36px;
            background: #2B54FC;
            box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 14px;
        }
        .test_detail {
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            width: 60px;
            height: 24px;
            text-align: center;
            display: block;
            font-weight: 500;
            font-size: 11px;
            line-height: 24px;
            color: #364556;
        }
    }

    .elTableClass th,
    .elTableClass td {
        padding: 0 !important;
        height: 20px; //需要的高度
        line-height: 20px;
    }
    .tab_box_self {
        background: #fff;
        padding-left: 24px;
        padding-right: 24px;
    }

    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
</style>
